module.exports = __webpack_public_path__ + "img/20180815_152858_225.24fe6064.jpg";